module.exports = __webpack_public_path__ + "static/media/energy-lantern.d9971acf.png";